'use client';

import { SmartVideo } from '@/app/_components/core/smart-video';
import type { VideoItem, VideoConsentLabels } from '@/app/_components/shared/video/video.types';
import { emptyToUndefined } from '@/app/_lib/utils';

interface VideoSlideProps {
  item: VideoItem;
  isActive: boolean;
  autoPlay?: boolean;
  imageSizes?: string;
  priority?: boolean;
  consentLabels?: VideoConsentLabels;
  onPlay?: () => void;
  trackingPrefix?: string;
}

export function VideoSlide({ item, isActive, autoPlay, imageSizes, priority, consentLabels, onPlay, trackingPrefix }: VideoSlideProps) {
  return (
    <SmartVideo
      type={item.type}
      video={item.video}
      youtubeId={emptyToUndefined(item.youtubeId)}
      previewImage={item.poster}
      title={emptyToUndefined(item.title)}
      imageSizes={imageSizes}
      priority={priority}
      consentLabels={consentLabels}
      isActive={isActive}
      autoPlay={autoPlay}
      onPlay={onPlay}
      trackingPrefix={trackingPrefix}
    />
  );
}
